import { render, staticRenderFns } from "./AxAxureLogoRow.vue?vue&type=template&id=aec2a628&"
import script from "./AxAxureLogoRow.vue?vue&type=script&lang=ts&"
export * from "./AxAxureLogoRow.vue?vue&type=script&lang=ts&"
import style0 from "./AxAxureLogoRow.vue?vue&type=style&index=0&id=aec2a628&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports